import { Slide } from '@features/powerpoint';
import { multiTouchAttributionSlide as baseSlide } from '@features/lci-report/slides/appendix/multi-touch-attribution/slide';

export const multiTouchAttributionSlide = (): Slide => {
  return baseSlide({
    title: 'Multi Touch Attribution (MTA)',
    metricType: 'sales',
  });
};
